module.exports = __webpack_public_path__ + "static/media/Matlandia5_przewodnik_po_zadaniach.684e37e3.pdf";